var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLnerLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 1216 965",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1154.11 -253V440.527C1154.11 474.52 1126.3 502.323 1092.3 502.323H121.755C87.7529 502.323 59.9424 530.126 59.9424 564.119V965",
    stroke: "#DF7E73",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.01 153L1157 153",
    stroke: "#DF7E73",
    strokeWidth: 15,
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0078 771L0.000399412 771",
    stroke: "#DF7E73",
    strokeWidth: 15,
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnerLine);
export default __webpack_public_path__ + "static/media/Lner_line.5631c4baa881fdced817bac7c5a4ea03.svg";
export { ForwardRef as ReactComponent };